import {useContext} from "react";
import SettingsContext from "../contexts/SettingsContext";

function useGetSetting(name)   {
    const {getSetting} = useContext(SettingsContext);
    return getSetting(name);
}
export default useGetSetting;